export const categories = [
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line', count: 1256, description: '心动时刻，甜蜜恋爱故事' },
  { slug: 'action', name: '热血动作', icon: 'ri-flashlight-line', count: 893, description: '激燃战斗，热血沸腾篇章' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line', count: 1102, description: '异世界穿越，无限想象空间' },
  { slug: 'bl', name: 'BL专区', icon: 'ri-star-line', count: 678, description: '唯美故事，心动治愈旅程' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-eye-line', count: 534, description: '烧脑剧情，步步惊心体验' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line', count: 921, description: '现实题材，触动心灵共鸣' },
]

export const allCategories = [
  ...categories,
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: 445, description: '轻松解压，欢乐治愈时光' },
  { slug: 'historical', name: '古风历史', icon: 'ri-archive-line', count: 367, description: '穿越古今，恢弘史诗篇章' },
  { slug: 'school', name: '校园青春', icon: 'ri-book-open-line', count: 589, description: '青春悸动，校园美好回忆' },
  { slug: 'slice-of-life', name: '治愈生活', icon: 'ri-plant-line', count: 412, description: '温暖日常，治愈人心故事' },
]

export const navCategories = allCategories
